import React from 'react';
import './WeddingPackages.css';
const handleAnchorClick = (e, target) => {
  e.preventDefault();

  const element = document.querySelector(target);

  if (element) {
    element.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  }
};

const packages = [
  {
    title: 'Silver Wedding',
    price: '₹9,999',
    tag: 'Elegant',
    vibe: 'Classic • Emotional • Beautiful',
    features: [
      '3 Cinematic Wedding Reel',
      'Bride & Groom Highlights',
      'Traditional Moments Coverage',
      '4K Edited Delivery',
    ],
  },
  {
    title: 'Royal Wedding',
    price: '₹14,999',
    tag: 'Most Booked',
    vibe: 'Luxury • Couple • Storytelling',
    features: [
      'Traditional Wedding Reels',
      'Candid Couple Film',
      'Baraat Coverage',
      'Premium Color Grading',
    ],
  },
  {
    title: 'GoSnap Pro',
    price: '₹24,999',
    tag: 'Ultra Premium',
    vibe: 'Luxury Experience • Cinematic Production',
    features: [
      'Wedding + Haldi + Sangeet Coverage',
      'Multiple Cinematic Reels',
      'Luxury Storytelling Edit',
      'Priority Same-Day Highlights',
    ],
    featured: true,
  },
];

const WeddingPackages = () => {
  return (
    <section className="wedding-packages" id="packages">
      <div className="floating-blur blur-one"></div>
      <div className="floating-blur blur-two"></div>

      <div className="container">
        <div className="packages-head reveal">
          <span className="packages-mini">Wedding & Event Experiences</span>

          <h2>
            Reels That Feel Like <span>Memories</span>
          </h2>

          <p>
            Cinematic instant reels crafted for weddings, haldi ceremonies,
            receptions, birthdays, engagements and unforgettable celebrations.
          </p>
        </div>
<div className="packages-offer-bar reveal">

  <div className="offer-block">

    <div className="offer-icon">
      🎟
    </div>

    <div className="offer-content">
      <small>Limited Time</small>
      <h4>
        Launch Offers <span>Live!</span>
      </h4>
    </div>

  </div>

  <div className="offer-block center">

    <div className="offer-icon soft">
      %
    </div>

    <div className="offer-content">
      <small>Exclusive Discounts</small>
      <p>
        On all <strong>Wedding & Event</strong> packages
      </p>
    </div>

  </div>

  <div className="offer-block right">

    <div className="offer-icon soft">
      🎁
    </div>

    <div className="offer-content">
      <small>Special Bonus</small>
      <p>
        Free instant teaser reel on selected bookings
      </p>
    </div>

  </div>

</div>
        <div className="packages-showcase">
          {packages.map((pkg, i) => (
            <div
              key={i}
              className={`creative-card ${pkg.featured ? 'featured' : ''}`}
            >
              <div className="card-glow"></div>

              <div className="card-top">
                <span className="package-tag">{pkg.tag}</span>
                <span className="package-vibe">{pkg.vibe}</span>
              </div>

              <div className="card-center">
                <h3>{pkg.title}</h3>

                <div className="creative-price">
                  {pkg.price}
                  <span>/event</span>
                </div>
              </div>

              <div className="creative-features">
                {pkg.features.map((feature, idx) => (
                  <div className="feature-pill" key={idx}>
                    {feature}
                  </div>
                ))}
              </div>

              <button className="creative-btn"   onClick={(e) => handleAnchorClick(e, '#contact')}
>
                Book Experience
              </button>
            </div>
          ))}
        </div>

        <div className="custom-package reveal">
          <div className="custom-left">
            <span>Need Something Unique?</span>
            <h3>Create Your Own Custom Event Package</h3>
            <p>
              From intimate ceremonies to luxury destination weddings, build a
              package exactly the way you want.
            </p>
          </div>

          <div className="custom-right">
            <div className="custom-bubble">Drone Shots</div>
            <div className="custom-bubble">Instant Reels</div>
            <div className="custom-bubble">Couple Films</div>
            <div className="custom-bubble">Baraat Coverage</div>
            <div className="custom-bubble">Same Day Edit</div>
            <button className="custom-btn"   onClick={(e) => handleAnchorClick(e, '#contact')}
>
              Build Custom Package
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WeddingPackages;